import { TableColumnsType } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { ProgramBookingDetailModal } from "../../wellnessProgram/program/booking/modal/update";
import { getAllReviewManageAdminResponse } from "../../../service/review";
import { useQuery } from "@tanstack/react-query";

export type TReviewFilterCategory = 'program' | 'wellnessLecture' | 'teacher';

const reviewFilterCategoryOptionsEnToKrMap: { [key in TReviewFilterCategory]: string } = {
    'program': '프로그램',
    'wellnessLecture': '클래스',
    'teacher': '코치',
}

const reviewFilterCategoryOptions: { label: string, value: TReviewFilterCategory }[] = [{ label: reviewFilterCategoryOptionsEnToKrMap['program'], value: 'program' }, { label: reviewFilterCategoryOptionsEnToKrMap['wellnessLecture'], value: 'wellnessLecture' }, { label: reviewFilterCategoryOptionsEnToKrMap['teacher'], value: 'teacher' }]

const reviewManageColumns: TableColumnsType<IReviewManageAdminResponse> = [
    {
        title: '작성일',
        dataIndex: 'createdDate',
        render: q => dayjs(q).format('YYYY-MM-DD')
    },
    {
        title: '작성자',
        dataIndex: 'memberName',
        render: (q, record) => <Link to={`/member/${record.memberId}`}>{q}</Link>
    },
    {
        title: '프로그램',
        render: (q, record) => record.isProgram ? record.programTitle : record.wellnessLectureName
    },
    {
        title: '담당 코치',
        dataIndex: 'teacherName',
        render: q => q ?? '-'
    },
    {
        title: '별점',
        dataIndex: 'rating',
        render: (q: number) => q.toFixed(1),
        sorter: (a, b) => a.rating - b.rating
    },
    {
        title: '리뷰 내용',
        dataIndex: 'content',
        width: '40%'
    },
    {
        title: '이용 일시',
        dataIndex: 'targetDateTime',
        render: q => dayjs(q).format('YYYY.MM.DD HH:mm')
    },
    {
        title: '예약 내역',
        dataIndex: 'isProgram',
        render: (q, record) => q ? <ProgramBookingDetailModal btnText="예약 상세" selectProgramBookingId={record.programBookingId} propsProgramId={record.programId} /> : <Link to={`/reservation/${record.reservationId}`}>예약 상세</Link>
    },
]



const useGetAllReviewManageAdminResponse = <T,>() => {
    const query = useQuery({
        queryKey: ['getAllReviewManageAdminResponse'],
        queryFn: () => getAllReviewManageAdminResponse<T>(),
        select: res => res.data.data.getAllReviewManageAdminResponse
    })

    return query;
}

export { reviewFilterCategoryOptionsEnToKrMap, reviewFilterCategoryOptions, reviewManageColumns, useGetAllReviewManageAdminResponse }